<template>
	<div class="appdl">
		<div class="xh-apph x-flow">
			<el-image class="home" :src="appdlhome"></el-image>
			<div class="x-label">{{ XhDev == 'cn' ? '（国内）' : '（Internal）'}}</div>
		</div>
		<div class="xh-appa x-flow">
			<el-image class="home" :src="appdlaboard"></el-image>
			<div class="x-label">{{ XhDev == 'cn' ? '（海外）' : '（Oversea）'}}</div>
		</div>
		<div class="bot-notice">
			{{ XhDev == 'cn' ? '扫描上方二维码下载 Xhorse APP' : 'Scan the QR code above to download Xhorse APP'}}
		</div>
	</div>
</template>
<style lang="css">

</style>
<script>
    import ElImage from "../../node_modules/element-ui/packages/image/src/main";
    import ElLink from "../../node_modules/element-ui/packages/link/src/main";
    import ElOption from "../../node_modules/element-ui/packages/select/src/option";
    import appdlhome from '../assets/images/XhorseApp-Home.png';
    import appdlaboard from '../assets/images/XhorseApp-Aboard.png';
    import XhDev from '../config/dev';
    export default {
        components: {
            ElOption,
            ElLink,
            ElImage
        },
        name: "appdl.vue",
        data: function () {
            return {
                appdlhome: appdlhome,
                appdlaboard: appdlaboard,
                XhDev: XhDev
            }
        },
        methods: {},
        created() {
        },
        mounted() {
            // 检测浏览器版本
            const browser = navigator.userAgent.toLowerCase();
            // 判断是否为小于IE11的浏览器
            if (browser.indexOf('compatible') > -1 && browser.indexOf('MSIE') > -1) {
                this.$confirm(
                '你的浏览器不支持本网站的访问，请使用较高版本浏览器浏览。',
                {
                    confirmButtonText: '确定',
                    type: 'warning'
                }
                ).then(
                function () {
                    window.close();
                    return;
                }
                );
            }

        }
    };
</script>

<style lang="css">
	div.appdl {
		width: 100%;
	}

	@media only screen and (width: 450px) {
		div.appdl .xh-appa {
			margin-left: -2.5rem;
		}
	}

	@media screen and (min-width: 450px) {
		div.appdl .xh-appa {
			margin-left: 2.5rem;
		}
	}

	div.appdl .x-flow {
		float: left;
	}

	div.appdl .xh-apph, .xh-appa {
		margin-top: 5rem;
		width: 12.5rem;
	}

	div.appdl .xh-apph {
		margin-left: calc((100% - 27.5rem) / 2);
	}

	div.x-label {
		width: 100%;
		text-align: center;
	}

	.xh-apph div.x-label {
		color: #DD8D1A;
	}

	.xh-appa div.x-label {
		color: #389FC7;
	}

	.xh-apph, .xh-appa .el-image {
		width: 100%;
	}

	div.appdl .bot-notice {
		clear: both;
		width: 100%;
		position: relative;
		top: 3.5rem;
		margin-bottom: 0rem;
		text-align: center;
		color: #888888;
		font-weight: 500;
	}
</style>



// WEBPACK FOOTER //
// src/components/appdl.vue